module.exports = "<svg viewBox=\"0 0 24 24\"><path d=\"M3,17H21V15H3V17M3,20H21V19H3V20M3,13H21V10H3V13M3,4V8H21V4H3Z\"></path></svg>"